import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { IStepper, Steps } from '~/app/core/models/types';
import { TranslateService } from '__services';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  @Output() selectionChanged = new EventEmitter();
  @Input() config?: IStepper;
  @Input() steps: Steps[];
  @Input() selectedIndex: number;
  @ViewChild('stepper') stepper: MatStepper;
  @Input() set stepperChanged(value) {
    if (value && this.stepper) {
      Object.assign(this.stepper, { _selectedIndex: this.selectedIndex });
    }
  }
  show: boolean = false;

  onSelectionChange(value): void {
    this.selectionChanged.emit(value);
  }



  constructor(
    private translateService: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.translateService.ready();
    this.show = true;
  }
}
